type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const ProblemCircleIcon = ({ size = 14, color = 'currentColor', className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM7 0.626953C3.48022 0.626953 0.626953 3.48022 0.626953 7C0.626953 10.5198 3.48022 13.373 7 13.373C10.5198 13.373 13.373 10.5198 13.373 7C13.373 3.48022 10.5198 0.626953 7 0.626953ZM6.99512 8.76172C7.43133 8.76175 7.79873 9.12825 7.79883 9.56445C7.79883 9.99071 7.43139 10.3584 6.99512 10.3584C6.55798 10.3584 6.20117 9.99072 6.20117 9.56445C6.20127 9.12823 6.55804 8.76172 6.99512 8.76172ZM7.74902 3.6416L7.55078 8.10645H6.43945L6.23047 3.6416H7.74902Z"
      fill={color}
    />
  </svg>
);
